// Route-line status colouring and schedule thresholds (#53-T8).
// Pure data — safe to import from the server.

export const SCHEDULE = {
  BEHIND_MIN_SLACK_HOURS: 12,   // spare time below this (or the ratio below) = "behind"
  BEHIND_SLACK_RATIO: 0.15,     // fraction of (hold + travel) hours
  STYLE_REFRESH_MS: 5000        // throttle for time:tick restyling
};

export const ROUTE_COLORS = {
  ok:       '#2ecc71',
  warn:     '#f39c12',
  critical: '#e74c3c',
  planned:  '#95a5a6'
};

// Fuel ratio (fuel / maxFuel) at or below which the route line changes colour.
export const FUEL_ROUTE_THRESHOLDS = {
  warn: 0.5,
  critical: 0.2
};
